import {
  createContext,
  useContext,
  useMemo,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';
import type { MediaDeviceSelection } from '@/components/pages/live/admin/MediaDeviceTester';

export type PretestDevicesContextValue = {
  readonly selection: MediaDeviceSelection | null;
  readonly setSelection?: Dispatch<SetStateAction<MediaDeviceSelection | null>>;
};

const PretestDevicesContext = createContext<PretestDevicesContextValue | null>(null);

export function PretestDevicesProvider({
  children,
  value,
  setSelection,
}: {
  children: ReactNode;
  value: MediaDeviceSelection | null;
  setSelection?: Dispatch<SetStateAction<MediaDeviceSelection | null>>;
}) {
  const ctx = useMemo(
    (): PretestDevicesContextValue => ({
      selection: value,
      setSelection,
    }),
    [value, setSelection],
  );
  return <PretestDevicesContext.Provider value={ctx}>{children}</PretestDevicesContext.Provider>;
}

export function usePretestDevices() {
  return useContext(PretestDevicesContext)?.selection ?? null;
}

export function usePretestDevicesSetSelection():
  | Dispatch<SetStateAction<MediaDeviceSelection | null>>
  | undefined {
  return useContext(PretestDevicesContext)?.setSelection;
}
